import { useState } from "react";
import "./news.css";

const contents = [
  {
    id: 1,
    date: "Nov 14",
    min: "3 min read",
    title: "U.S. Coast Guard Takes Over Cleanup of $3M Yacht",
    content:
      "Lorem ipsum dolor sit amet consectetur. Semper ut aliquam aliquet magna felis ac fermentum. Sem risus consectetur morbi arcu consequat leo tellus tincidunt porta. Auctor pretium donec ultrices tristique ",
  },
  {
    id: 2,
    date: "Nov 14",
    min: "3 min read",
    title: "U.S. Coast Guard Takes Over Cleanup of $3M Yacht",
    img: "https://res.cloudinary.com/dquhjbqzf/image/upload/v1725646641/Rectangle_206004_pyb09n.png",
  },
  {
    id: 3,
    date: "Nov 14",
    min: "3 min read",
    title: "U.S. Coast Guard Takes Over Cleanup of $3M Yacht",
    content:
      "Lorem ipsum dolor sit amet consectetur. Semper ut aliquam aliquet magna felis ac fermentum. Sem risus consectetur morbi arcu consequat leo tellus tincidunt porta. Auctor pretium donec ultrices tristique ",
  },
  {
    id: 4,
    date: "Nov 14",
    min: "3 min read",
    title: "U.S. Coast Guard Takes Over Cleanup of $3M Yacht",
    content:
      "Lorem ipsum dolor sit amet consectetur. Semper ut aliquam aliquet magna felis ac fermentum. Sem risus consectetur morbi arcu consequat leo tellus tincidunt porta. Auctor pretium donec ultrices tristique ",
  },
  {
    id: 5,
    date: "Nov 14",
    min: "3 min read",
    title: "U.S. Coast Guard Takes Over Cleanup of $3M Yacht",
    content:
      "Lorem ipsum dolor sit amet consectetur. Semper ut aliquam aliquet magna felis ac fermentum. Sem risus consectetur morbi arcu consequat leo tellus tincidunt porta. Auctor pretium donec ultrices tristique ",
  },
];

const newsItems = [
  {
    date: "Nov 14",
    title: "U.S. Coast Guard Takes Over Cleanup of $3M Yacht",
    description:
      "Lorem ipsum dolor sit amet consectetur. Consequat iaculis vitae mattis eget nibh amet. Maecenas ut in viverra eu quisque. Curabitur et fermentum ac eget nisl dis vitae et. Luctus at felis consectetur tincidunt est vitae.",
    time: "3 min read",
  },
  {
    date: "Nov 14",
    title: "U.S. Coast Guard Takes Over Cleanup of $3M Yacht",
    description:
      "Lorem ipsum dolor sit amet consectetur. Consequat iaculis vitae mattis eget nibh amet. Maecenas ut in viverra eu quisque. Curabitur et fermentum ac eget nisl dis vitae et. Luctus at felis consectetur tincidunt est vitae.",
    time: "3 min read",
  },
  {
    date: "Nov 14",
    title: "U.S. Coast Guard Takes Over Cleanup of $3M Yacht",
    description:
      "Lorem ipsum dolor sit amet consectetur. Consequat iaculis vitae mattis eget nibh amet. Maecenas ut in viverra eu quisque. Curabitur et fermentum ac eget nisl dis vitae et. Luctus at felis consectetur tincidunt est vitae.",
    time: "3 min read",
  },
  {
    date: "Nov 14",
    title: "U.S. Coast Guard Takes Over Cleanup of $3M Yacht",
    description:
      "Lorem ipsum dolor sit amet consectetur. Consequat iaculis vitae mattis eget nibh amet. Maecenas ut in viverra eu quisque. Curabitur et fermentum ac eget nisl dis vitae et. Luctus at felis consectetur tincidunt est vitae.",
    time: "3 min read",
  },
  {
    date: "Nov 14",
    title: "U.S. Coast Guard Takes Over Cleanup of $3M Yacht",
    description:
      "Lorem ipsum dolor sit amet consectetur. Consequat iaculis vitae mattis eget nibh amet. Maecenas ut in viverra eu quisque. Curabitur et fermentum ac eget nisl dis vitae et. Luctus at felis consectetur tincidunt est vitae.",
    time: "3 min read",
  },
];

const Newsinsignt = () => {
  const [latest, setLatest] = useState(true);
  const [popular, setPopular] = useState(false);

  const handleLatest = () => {
    setLatest(true);
    setPopular(false);
  };

  const handlePopular = () => {
    setLatest(false);
    setPopular(true);
  };

  return (
    <div className="news">
      <div className="wrap">
      <div className="what">
        <h3>Latest News</h3>
        <div className="card-container">
          {contents.map((item, index) => (
            <div
              key={item.id}
              className={`item-card ${index === 1 ? "highlight-card" : ""}`}
            >
              <div className="meta">
                <p>{item.date}</p>
                <p>{item.min}</p>
              </div>
              <h3>{item.title}</h3>
              <p>{item.content}</p>
              <img src={item.img} alt="" />
            </div>
          ))}
        </div>
      </div>

      {/* Switch Tabs */}
      <div className="switch">
        <p onClick={handleLatest} className={latest ? "active" : ""}>
          Latest
        </p>
        <p onClick={handlePopular} className={popular ? "active" : ""}>
          Popular
        </p>
      </div>

      {latest && (
        <div className="content">
          {/* News List */}
          <div className="news-list">
            {newsItems.map((item, index) => (
              <div key={index} className="news-card">
                <div className="header">
                  <p className="date">{item.date}</p>
                  <p className="time">{item.time}</p>
                </div>
                <h3 className="title">{item.title}</h3>
                <p className="description">{item.description}</p>
              </div>
            ))}
          </div>

          {/* Ad Space */}
          <div className="ad-space">
            <p>Space for ads</p>
          </div>
        </div>
      )}

      {popular && (
        <div className="popular">
          <h3>Coming soon!</h3>
        </div>
      )}
       </div>
    </div>
  );
};

export default Newsinsignt;
